import React, { Component } from "react";
import "./Seo.scss";
import { Link, withRouter } from "react-router-dom";

class Seo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSelectedScheme = (value, item) => {
    let schemeName = item.scheme_name.replace(" ", "_");
    for (let i = 0; i < item.scheme_name.length; i++) {
      schemeName = schemeName.replace(" ", "_");
      schemeName = schemeName.replace("-", "_");
    }
    window.open(
      `/mutual-funds/${schemeName + "/" + item.scheme_code}`,
      "_blank"
    );
  };

  handleFundHouse = (data, index) => {
    let selectedFund = data;
    window.open(`/fund_house/${selectedFund}`, "_blank");
  };
  render() {
    let FundHouse = [
      "Aditya Birla Sun Life AMC Limited",
      "Axis Asset Management Company Ltd",
      "Baroda Asset Management India Limited",
      "BNP Paribas Asset Management India Pvt. Ltd",
      "BOI AXA Investment Managers Private Limited",
      "Canara Robeco Asset Management Company Limited",
      "DSP Investment Managers Private Limited",
      "Edelweiss Asset Management Limited",
      "Franklin Templeton Asset Management (India) Private Limited",
      "HDFC Asset Management Company Limited",
      "HSBC Global Asset Management (India) Private Limited",
      "ICICI Prudential Asset Management Company Limited",
      "IDBI Asset Management Ltd",
      "IDFC Asset Management Company Limited",
      "IIFL Asset Management Co. Ltd.",
      "Indiabulls Asset Management Company Limited",
      "Invesco Asset Management Company Pvt Ltd.",
      "ITI Asset Management Limited",
      "JM Financial Asset Management Private Limited",
      "Kotak Mahindra Asset Management Company Limited",
      "L&T Investment Management Limited",
      "LIC Mutual Fund Asset Management Limited",
      "Mahindra Manulife Investment Management Private Limited",
      "Mirae Asset Investment Managers (India) Private Limited",
      "Motilal Oswal Asset Management Company Limited",
      "Navi AMC Limited",
      "Nippon Life India Asset Management Limited",
      "NJ Asset Management Private Limited",
      "PGIM India Asset Management Private Limited",
      "PPFAS Asset Management Pvt. Ltd.",
      "Quant Money Managers Limited",
      "Quantum Asset Management Company Private Limited",
      "Samco Asset Management Private Limited",
      "SBI Funds Management Limited",
      "Shriram Asset Management Company Limited",
      "Sundaram Asset Management Company Limited",
      "Tata Asset Management Private Limited",
      "Taurus Asset Management Company Limited",
      "Trust Asset Management Private Limited",
      "Union Asset Management Company Pvt. Ltd.",
      "UTI Asset Management Company Private Limited",
      "WhiteOak Capital Asset Management Limited",
    ];
    let fundList = [
      { scheme_name: "Quant Small Cap Fund", scheme_code: "100177" },
      { scheme_name: "Axis Blue Chip Fund ", scheme_code: "112277" },
      {
        scheme_name: "Mirae Asset Emerging Bluechip Fund ",
        scheme_code: "112932",
      },
      { scheme_name: "Mirae Asset Tax Saver ", scheme_code: "135784" },
      { scheme_name: "SBI Bluechip Fund", scheme_code: "103504" },
      { scheme_name: "ICICI Prudential", scheme_code: "102528" },
      { scheme_name: "HDFC Top 100 Fund", scheme_code: "102000" },
      { scheme_name: "Kotak Bluechip Fund ", scheme_code: "114458" },
      { scheme_name: "Canara Robeco Bluechip Fund ", scheme_code: "113221" },
      { scheme_name: "IDFC Multi Cap Fund ", scheme_code: "149305" },
      {
        scheme_name: "ICICI Prudential Value Discovery Fund ",
        scheme_code: "102894",
      },
      { scheme_name: "DSP Small Cap Fund ", scheme_code: "105989" },
      { scheme_name: "Axis Small Cap Fund", scheme_code: "125350" },
      { scheme_name: "Parag Parikh Tax Saver", scheme_code: "147482" },
    ];
    return (
      <>
        <div className="seo_section">
          <div className="container p-4">
            <div className="mutual_funds">
              <p className="font_color d-inline">APIs for FinTech</p>
              <span className="sepreration mx-1">
                <b> | </b>
              </span>
              <p className="font_color d-inline">APIs for Robo Advisors</p>
              <span className="sepreration mx-1">
                <b> | </b>
              </span>
              <p className="font_color d-inline">APIs for Mutual Fund</p>
              <span className="sepreration mx-1">
                <b> | </b>
              </span>
              <p className="font_color d-inline">APIs for MF Transactions</p>
              <span className="sepreration mx-1">
                <b> | </b>
              </span>
              <p className="font_color d-inline">APIs for MF Platform</p>
            </div>
            <div className="mutual_funds my-3">
              <p className="font_color d-inline">Mutual Fund Software</p>
              <span className="sepreration mx-1">
                <b> | </b>
              </span>
              <p className="font_color d-inline">Mutual Fund Research</p>
              <span className="sepreration mx-1">
                <b> | </b>
              </span>
              <p className="font_color d-inline">Online MF Transactions</p>
              <span className="sepreration mx-1">
                <b> | </b>
              </span>
              <p className="font_color d-inline">A Risk Profiling Software</p>
              <span className="sepreration mx-1">
                <b> | </b>
              </span>
              <p className="font_color d-inline">
                Mutual Fund Reporting Software
              </p>
            </div>
            <div className="api_documentation mt-5">
              <p className="font_white d-inline">API DOCUMENTATION</p>
              <span className="sepreration">
                <b> : </b>
              </span>
              <a
                href="https://documenter.getpostman.com/view/4406068/RWaRN5cC#a2c75c0b-09fd-4955-a7a7-d42eeaef3164"
                target="_blank"
                rel="noopener noreferrer"
                className="click_font d-inline "
              >
                Mutual Fund Data APIs
              </a>
              <span className="sepreration mx-1">
                <b> | </b>
              </span>
              <a
                href="https://documenter.getpostman.com/view/4406068/UVXjJvFB"
                target="_blank"
                rel="noopener noreferrer"
                className="click_font d-inline "
              >
                Robotics APIs
              </a>
              <span className="sepreration mx-1">
                <b> | </b>
              </span>
              <a
                href="https://documenter.getpostman.com/view/4406068/Tz5qYwTd"
                target="_blank"
                rel="noopener noreferrer"
                className="click_font d-inline "
              >
                MF Transactions APIs
              </a>
              <span className="sepreration mx-1">
                <b> | </b>
              </span>
              <a
                href="https://documenter.getpostman.com/view/4406068/UVXjJvKZ"
                target="_blank"
                rel="noopener noreferrer"
                className="click_font d-inline "
              >
                Investment Reporting APIs
              </a>
              <span className="sepreration mx-1">
                <b> | </b>
              </span>
              <a
                href="https://documenter.getpostman.com/view/4406068/UVXjKbMy"
                target="_blank"
                rel="noopener noreferrer"
                className="click_font d-inline "
              >
                Risk Profiling APIs
              </a>
            </div>
            <div className="mutual_funds my-5">
              <p className="font_white d-inline">Fund House</p>
              <span className="sepreration">
                <b> : </b>
              </span>
              {FundHouse.map((data, index) => {
                return (
                  <>
                    <p
                      className="click_font  d-inline"
                      onClick={() => this.handleFundHouse(data, index)}
                    >
                      {data}
                    </p>
                    <span className="sepreration mx-1">
                      <b> | </b>
                    </span>
                  </>
                );
              })}
            </div>
            <div className="mutual_funds my-5">
              <p className="font_white d-inline">Mutual Fund</p>
              <span className="sepreration">
                <b> : </b>
              </span>
              {fundList.map((data, index) => {
                return (
                  <>
                    <p
                      className="click_font d-inline"
                      onClick={() => this.handleSelectedScheme(data, data)}
                    >
                      {data.scheme_name}
                    </p>
                    <span className="sepreration mx-1">
                      <b> | </b>
                    </span>
                  </>
                );
              })}
            </div>
            <div className="mutual_funds text-center my-5">
              <Link
                to="/about_us"
                target="_blank"
                className="font_white d-inline "
              >
                About Us
              </Link>
              <span className="sepreration_2">
                <b>|</b>
              </span>
              {/* <Link
                to="/terms_conditions"
                target="_blank"
                className="font_white d-inline "
              >
                Terms & Conditions
              </Link>
              <span className="sepreration_2">
                <b>|</b>
              </span> */}
              <Link
                to="/privacy_policy"
                target="_blank"
                className="font_white d-inline "
              >
                Privacy Policy
              </Link>
              <span className="sepreration_2">
                <b>|</b>
              </span>
              <Link
                to="/refund_policy"
                target="_blank"
                className="font_white d-inline "
              >
                Refund Policy
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(Seo);
